import axios from "axios";
import config from "../Config.json";


const SupportMailSend = async(data) => {
    try {   
        try {
            const response = await axios.post(`${config.API_URL}/app/supportMail`, data)
        return response
        } catch (error) {
            return []
        }
    } catch (error) {
        return error
    }
}

export default SupportMailSend